import React from 'react';
import { Lightning } from '@phosphor-icons/react';

export const FastResponderBadge = ({ size = 'sm' }) => {
  const compact = size === 'sm';
  return (
    <span
      className={`inline-flex items-center gap-1 bg-amber-400 text-[#0F172A] font-black uppercase tracking-widest rounded border-2 border-black ${
        compact ? 'px-1.5 py-0.5 text-[9px]' : 'px-2 py-1 text-[10px]'
      }`}
      title="Typically replies within an hour"
      data-testid="fast-responder-badge"
    >
      <Lightning size={compact ? 10 : 12} weight="fill" />
      Fast Responder
    </span>
  );
};

export default FastResponderBadge;
